module.exports = __webpack_public_path__ + "img/tickets.1b900446.svg";